export const getToken = state => state.token;
export const getIsLoading = state => state.isLoading;